
import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from 'react-router-dom'
import Loader from "./components/common/Loader";
import PortalLayout from "@/components/layout/PortalLayout";
import { useAuthSync } from "./stores/useAuthSync";
import { ProtectedRoutesProvider } from "./components/ProtectedRoutesProvider";
import NotFound from "./components/common/NotFound";
import { AnimatePresence, motion } from "framer-motion";
import PointIconLoader from "./components/common/PointIconLoader";

// * Lazy load pages to improve initial load performance.
const LoginPage = lazy(() => import('@/pages/login'))
const HomePage = lazy(() => import('@/pages/portal/home'))
const ProfilePage = lazy(() => import('@/pages/portal/profile'))
const RewardsPage = lazy(() => import('@/pages/portal/rewards'))
const TransactionsPage = lazy(() => import('@/pages/portal/transactions'))
const AboutPage = lazy(() => import('@/pages/portal/about'))
const SignupPage = lazy(() => import('@/pages/signup'))
const VerifyPage = lazy(() => import('@/pages/signup/verify'))
const TermsPage = lazy(() => import('@/pages/terms'))
const PolicyPage = lazy(() => import('@/pages/policy'))

export default function RoutesComponent() {
  const { isLoading } = useAuthSync();

  return (
    <Suspense fallback={<Loader />}>
      <AnimatePresence mode="wait">
        <motion.div
          key="portal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.5 }}
        >
          <Routes>
            {/* Public Routes */}
            <Route path="" element={
              <div className="h-full w-full">
                {isLoading ?
                  // TODO: REMOVE ADD A MORE UI FRIENDLY PAGE
                  <div className="min-h-screen flex flex-col justify-center items-center">
                    {/* 
                            // TODO: REMOVE Add a common Welcome component with animations (curtain/door open effect) and 1s wait before redirect to home.
                            */}
                    {/* <div className='w-full h-full flex flex-col justify-between items-center p-6 gap-6'>
                  <div className="w-full text-3xl lg:text-4xl text-center font-semibold">Setting up</div>
                  <RocketLoader loaderClassname="h-48 w-48 lg:h-64 lg:w-64" />
                  <div className="text-xl lg:text-2xl text-center animate-pulse">Taking you to the home page...</div>
                </div> */}
                    {/* <Loader loaderText="Setting up portal" /> */}
                    <PointIconLoader loaderText="Setting up portal" />
                  </div>
                  :
                  <Navigate to="/login" />
                }
              </div>
            } />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/verify" element={<VerifyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy-policy" element={<PolicyPage />} />

            {/* Protected Routes */}
            <Route
              path="auth"
              element={<ProtectedRoutesProvider children={<PortalLayout />} />}
            >
              <Route index path="" element={<HomePage />} />
              <Route index path="home" element={<HomePage />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="rewards" element={<RewardsPage />} />
              <Route path="transactions" element={<TransactionsPage />} />
              <Route path="about" element={<AboutPage />} />
            </Route>

            {/* 404 Route */}
            <Route path="*" element={<NotFound />} />
            <Route path="not-found" element={<NotFound />} />
          </Routes>
        </motion.div>
      </AnimatePresence>
    </Suspense>
  )
}